import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { LayoutWithBannerNavbarFooter } from 'layouts';
import ultilitiesService from 'shared/util/ultilitiesService';
import './InvestmentSummary.scss';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import background from 'assets/images/risk-profile-bg.png';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  ItemList, RiskStatus, BottomNav,
  // BottomButton,
} from 'components';
import { PATH , COMPONENT_TYPE} from 'shared/constants';
import { getRTL } from 'shared/redux/selectors';
import { toggleLanguage, updateInputComponent } from 'shared/redux/actions';
import arrowWhite from 'assets/icons/nextWhite.svg';

const statusBarClass = 'status-bar--investment-summary';

const InvestmentSummary = ({
  summary, intl, history, currentLocale, isRtl, onUpdateInputComponent
}) => {
  useEffect(() => {
    document.body.classList.add(statusBarClass);
    return () => {
      document.body.classList.remove(statusBarClass);
    };
  });

  useEffect( () => {
    onUpdateInputComponent(COMPONENT_TYPE.INVESTMENT_SUMMARY);
  }, [onUpdateInputComponent]);

  const toTranslate = [
    'summary.age',
    'summary.risk',
    // 'summary.regulatoryClassification',
    'summary.geographicalInterest',
    'summary.investmentPreference',
    'summary.goal',
    'summary.targetCompletion',
  ];

  const orderedKeys = [
    'summary.name',
    'summary.age',
    'summary.risk',
    'summary.investmentPreference',
    'summary.geographicalInterest',
    // 'summary.regulatoryClassification',
    'summary.goal',
    'summary.targetAmount',
    'summary.targetCompletion',
    'summary.initialInvestment',
    'summary.annualInvestment',
  ];

  const processGeographicalReply = (reply) => {
    let value = [];
    if (reply.includes('askGeographically.convo.quick_replies.3')) {
      value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.3' }));
    }
    if (reply.includes('askGeographically.convo.quick_replies.2')) {
      value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.2' }));
    }
    if (reply.includes('askGeographically.convo.quick_replies.4')) {
      value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.4' }));
    }
    if (reply.includes('askGeographically.convo.quick_replies.5')) {
      value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.5' }));
    }
    if (reply.includes('askGeographically.convo.quick_replies.1')) {
      value = [intl.formatMessage({ id: 'askGeographically.convo.quick_replies.1' })];
    }
    value = value.join(', ');
    if (reply === 'not_applicable') {
      value = 'N/A';
    }
    return value;
  };

  const processValue = (key) => {
    if (key === 'summary.age') {
      const options = {
        singular: intl.formatMessage({ id: 'investment_summary.yearOld' }),
        plural: intl.formatMessage({ id: 'investment_summary.yearsOld' }),
      };
      return ultilitiesService.yearBuilder(summary[key], options);
    }
    if (key === 'summary.targetCompletion') {
      const options = {
        singular: intl.formatMessage({ id: 'year' }),
        plural: intl.formatMessage({ id: 'years' }),
      };
      return ultilitiesService.yearBuilder(summary[key], options);
    }
    if (key === 'summary.regulatoryClassification') {
      // eslint-disable-next-line prefer-destructuring
      const res = intl.formatMessage({ id: summary[key] }, { textQualified: 'empty', textRetail: 'empty' });
      if (res.includes('،')) {
        return res.split('،')[1];
      }
      return res.split(',')[1];
    }
    if (key === 'summary.geographicalInterest') {
      return processGeographicalReply(summary[key]);
    }
    return intl.formatMessage({ id: summary[key] });
  };

  return (
    <LayoutWithBannerNavbarFooter
      title="summary.title"
      // leftButton={<FontAwesomeIcon icon={faLongArrowAltLeft} />}
      leftButton={(<span className="arrow"><img src={arrowWhite} alt="arrow" /></span>)}
      onLeftClick={() => history.push(PATH.JOURNEY_OVERVIEW)}
      rightButton={ultilitiesService.locale(currentLocale)}
      onRightClick={() => history.push(PATH.LANGUAGE)}
      background={background}
      className="nw-page-summary"
      bannerText={<RiskStatus />}
      isRtl={isRtl}
      footerChildren={(
        <>
          {/* <BottomButton
            value={intl.formatMessage({ id: history.location.state && history.location.state.isFromStep ? 'summary.looksGood' : 'summary.digitalAdvice' })}
            onButtonClick={() => history.push(PATH.ASSETS_ALLOCATION)}
            isOutlineButton
          /> */}
          <BottomNav
            altStyle
            rtl={isRtl}
            leftButton={intl.formatMessage({ id: 'summary.startOver' })}
            onLeftClick={() => history.push(PATH.JOURNEY_OVERVIEW)}
            rightButton={intl.formatMessage({ id: history.location.state && history.location.state.isFromStep ? 'summary.looksGood' : 'summary.digitalAdvice' })}
            onRightClick={() => history.push(PATH.ASSETS_ALLOCATION)}
          />
        </>
      )}
    >
      <h2><FormattedMessage id="summary.yourInvestorProfile" /></h2>

      <ItemList
        rtl={isRtl}
        data={orderedKeys.map(key => ({
          label: intl.formatMessage({ id: key }),
          value: (toTranslate.includes(key) && summary[key]) ? processValue(key) : summary[key],
          // value: (toTranslate.includes(key) && summary[key]) ? intl.formatMessage({ id: summary[key] }) : summary[key],
        }))}
      />
    </LayoutWithBannerNavbarFooter>
  );
};

const mapStateToProps = state => ({
  summary: state.rootReducer.summary,
  currentLocale: state.rootReducer.language.locale,
  isRtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = dispatch => ({
  onSwitchLanguage: () => dispatch(toggleLanguage()),
  onUpdateInputComponent: (inputComponent) => dispatch(updateInputComponent(inputComponent)),
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(InvestmentSummary));
